var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconDirectChat(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.8603 7.35055C10.8603 7.7716 10.5796 8.05231 10.1585 8.05231H3.41714C3.24033 8.05231 3.07076 8.12254 2.94574 8.24757L0.333984 10.8593V1.03476C0.333984 0.61371 0.614686 0.333008 1.03574 0.333008H10.1585C10.5796 0.333008 10.8603 0.61371 10.8603 1.03476V7.35055ZM12.0493 2.43827H12.9554C13.3826 2.43827 13.6673 2.71897 13.6673 3.14003V13.6663L10.8197 11.2784H3.8529C3.42576 11.2784 3.141 10.9977 3.141 10.5766V9.76816C3.141 9.39997 3.43948 9.10149 3.80767 9.10149H11.3826C11.7508 9.10149 12.0493 8.80302 12.0493 8.43483V2.43827Z",
    fill: "#3456FF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDirectChat);
export default __webpack_public_path__ + "static/media/icon-direct-chat.8433b56cdc8c465edefd21f0ab68e64c.svg";
export { ForwardRef as ReactComponent };